module.exports = __webpack_public_path__ + "assets/img/5f877e62c1f7dc82cefe92e43bd6dfa2.svg";